<template>
    <div>
        <v-icon v-if="condition" :color="successColor">{{ successIcon }}</v-icon>
        <v-icon v-else :color="fallbackColor">{{ fallbackIcon }}</v-icon>
    </div>
</template>

<script>
    export default {
        props: {
            condition: {
                type: Boolean,
                required: true
            },
            successColor: {
                type: String,
                required: false,
                default: 'green'
            },
            fallbackColor: {
                type: String,
                required: false,
                default: 'grey'
            },
            successIcon: {
                type: String,
                required: false,
                default: 'mdi-check-circle'
            },
            fallbackIcon: {
                type: String,
                required: false,
                default: 'mdi-cancel'
            }
        }
    }
</script>
